module.exports = __webpack_public_path__ + "img/pexels-anfisa-eremina-2543042.fe848e08.jpg";